import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
const Noop = () => null;
Noop.displayName = "NotEnabledInProduction";
let TenantSelector = Noop;
if (process.env.NODE_ENV === "development") {
    const LazyTenantSelector = lazy(() => import(/* webpackChunkName: "tenant-selector"  */ "./TenantSelector"));
    TenantSelector = () => (_jsx(Suspense, { fallback: _jsx(Noop, {}), children: _jsx(LazyTenantSelector, {}) }));
}
export default TenantSelector;
//# sourceMappingURL=HiddenInProductionTenantSelector.js.map